import { useMemo } from 'react'
import { Trans, useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import { useAuth } from '@/features/auth'
import Input from '@/components/ui/Input'
import Title from './Title'
import InputTile from './InputTile'
import { TRANSLATABLE_FIELDS } from '../hooks/useBranding'

export default function Messages() {
  const { t } = useLingui()
  const { currentUser } = useAuth()

  const userName = useMemo(() => {
    return `${currentUser?.givenName} ${currentUser?.lastName}`
  }, [currentUser])

  return (
    <InputTile>
      <Form.Translation translatableFields={TRANSLATABLE_FIELDS}>
        <Title
          title={t`Guest Messages`}
          description={t`Messages that are shown to the guest to better personalize their stay, when they go into their guest area.`}
        />
        <Form.Field
          name="messageNotloggedin"
          label={t`Not connected Message`}
          description={t`The message used when a guest on the app isn't connected. This could be an external visitor or a guest that is not yet at the hotel.`}
          size="small"
          rules={{
            maxLength: {
              value: 255,
              message: t`Can't be longer than 255 characters.`
            }
          }}
        >
          {({ renderProps: { onChange, value, ...props } }) => (
            <Input
              value={value}
              onChange={event => onChange(event.target.value)}
              type="text"
              placeholder={t`Hello`}
              {...props}
            />
          )}
        </Form.Field>
        <Form.Field
          name="messageMorning"
          label={t`Morning Message`}
          size="small"
          rules={{
            maxLength: {
              value: 255,
              message: t`Can't be longer than 255 characters.`
            }
          }}
        >
          {({ renderProps: { onChange, value, ...props } }) => (
            <>
              <Input
                onChange={event => onChange(event.target.value)}
                type="text"
                placeholder={t`Good morning`}
                value={value}
                {...props}
              />
              <span className="pl-2 text-regular text-text-light">
                <Trans>Example</Trans>: {value ?? t`Good morning`} {userName}
              </span>
            </>
          )}
        </Form.Field>
        <Form.Field
          name="messageNoon"
          label={t`Noon Message`}
          size="small"
          rules={{
            maxLength: {
              value: 255,
              message: t`Can't be longer than 255 characters.`
            }
          }}
        >
          {({ renderProps: { onChange, value, ...props } }) => (
            <>
              <Input
                value={value}
                onChange={event => onChange(event.target.value)}
                type="text"
                placeholder={t`Have a good meal`}
                {...props}
              />
              <span className="pl-2 text-regular text-text-light">
                <Trans>Example</Trans>: {value ?? t`Have a good meal`}{' '}
                {userName}
              </span>
            </>
          )}
        </Form.Field>
        <Form.Field
          name="messageAfternoon"
          label={t`Afternoon Message`}
          size="small"
          rules={{
            maxLength: {
              value: 255,
              message: t`Can't be longer than 255 characters.`
            }
          }}
        >
          {({ renderProps: { onChange, value, ...props } }) => (
            <>
              <Input
                value={value}
                onChange={event => onChange(event.target.value)}
                type="text"
                placeholder={t`Have a nice day`}
                {...props}
              />
              <span className="pl-2 text-regular text-text-light">
                <Trans>Example</Trans>: {value ?? t`Have a nice day`} {userName}
              </span>
            </>
          )}
        </Form.Field>
        <Form.Field
          name="messageEvening"
          label={t`Evening Message`}
          size="small"
          rules={{
            maxLength: {
              value: 255,
              message: t`Can't be longer than 255 characters.`
            }
          }}
        >
          {({ renderProps: { onChange, value, ...props } }) => (
            <>
              <Input
                value={value}
                onChange={event => onChange(event.target.value)}
                type="text"
                placeholder={t`Good evening`}
                {...props}
              />
              <span className="pl-2 text-regular text-text-light">
                <Trans>Example</Trans>: {value ?? t`Good evening`} {userName}
              </span>
            </>
          )}
        </Form.Field>
      </Form.Translation>
    </InputTile>
  )
}
